import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MdLockOutline } from "react-icons/md";

const LoginModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="bg-white p-6 rounded-2xl shadow-lg w-[90%] max-w-md text-center"
      >
        {/* Lock Icon */}
        <div className="flex justify-center mb-3">
          <MdLockOutline className="text-blue-600 text-4xl" />
        </div>

        {/* Heading */}
        <h2 className="text-2xl font-semibold text-gray-800">Login Required</h2>
        <p className="text-gray-600 mt-2">
          You need to log in to access this feature.
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-5">
          <button
            className="bg-blue-600 text-white px-5 py-2 rounded-lg shadow-md hover:bg-blue-700 transition duration-200"
            onClick={handleLogin}
          >
            Login
          </button>
          <button
            className="bg-gray-300 text-gray-700 px-5 py-2 rounded-lg shadow-md hover:bg-gray-400 transition duration-200"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginModal;
